import { Button, Card, Col, Form, Input, Row, Select, message } from "antd";
import { useContext, useState } from "react";
import { FiEdit2 } from "react-icons/fi";
import CustomerLayout from "../../Components/CustomerLayout/CustomerLayout";
import { AuthContext } from "../../Contexts/AuthContext";
import axios from "../../config/axios";
import styles from "./CustomerDataPayment.module.scss";

const CustomerDataPayment = () => {
    const [form] = Form.useForm();
    const { user } = useContext(AuthContext);
    const [billingUpdateLoading, setBillingUpdateLoading] = useState(false);

    // update the billing info
    const updateBillingInfo = async (values) => {
        try {
            setBillingUpdateLoading(true);
            await axios.patch("/users/update", values, { withCredentials: true });
            message.success("Payment info updated successfully!");
        } catch (error) {
            message.error("A server side error occurred!");
        } finally {
            setBillingUpdateLoading(false);
        }
    };

    return (
        <CustomerLayout
            breadcrumb={[
                {
                    name: "Back to Home",
                    link: "/",
                },
                {
                    name: "Customer Service",
                    link: "/customer/customer-service",
                },
            ]}
        >
            <div className={styles.top_title}>
                <img src="https://desi-fresh.b-cdn.net/components_static/sidebar_icons/data-payment-active.svg" alt="coupon" height={40} />
                <h3>Data and Payment</h3>
            </div>

            <Card
                bordered={false}
                style={{
                    boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
                    marginTop: "20px",
                    padding: "0 100px",
                }}
            >
                <div className={styles.payment_info_top}>
                    <div>Payment Information</div>
                    <FiEdit2 size={20} />
                </div>
                <div>
                    <Form
                        onFinish={updateBillingInfo}
                        layout="vertical"
                        requiredMark={false}
                        initialValues={{
                            ...user,
                        }}
                        form={form}
                    >
                        <Row gutter={[30, 0]}>
                            <Col span={6}>
                                <Form.Item
                                    name="b_title"
                                    label="Title"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select a title"
                                        allowClear
                                        options={[
                                            {
                                                name: "Mr.",
                                                value: "Mr.",
                                            },
                                            {
                                                name: "Mrs.",
                                                value: "Mrs.",
                                            },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={18}></Col>
                            <Col span={12}>
                                <Form.Item
                                    label="First Name *"
                                    name="b_first_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your first name!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Last Name *"
                                    name="b_last_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your last name!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Street Address *"
                                    name="b_street_address"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your street address!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="ZIP / Postal Code *"
                                    name="b_zip_code"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your zip code!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="City / Town *"
                                    name="b_city"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your city!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="State / Region" name="s_state">
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="Country *"
                                    name="b_country"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your country!",
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select a country"
                                        options={[
                                            {
                                                name: "Germany",
                                                value: "Germany",
                                            },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="Bank Name" name="b_state">
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="Bank Account Number" name="b_state">
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="IBAN" name="b_state">
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end", // optional: aligns the button to the right
                                        textAlign: "right", // aligns the button to the right
                                    }}
                                >
                                    <Button
                                        loading={billingUpdateLoading}
                                        disabled={billingUpdateLoading}
                                        htmlType="submit"
                                        style={{ padding: "0 5rem", background: "#EAE8E8" }}
                                    >
                                        Save
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Card>

            <br />

            {/* <Card
                bordered={false}
                style={{
                    boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
                    marginTop: "20px",
                    padding: "0 100px",
                }}
            >
                <div className={styles.payment_info_top}>
                    <div>Billing and Renewal Settings</div>
                    <FiEdit2 size={20} />
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                        marginBottom: "1rem",
                    }}
                >
                    <span
                        style={{
                            fontWeight: "bold",
                        }}
                    >
                        Saved Payment Profiles
                    </span>
                    <span style={{ color: "var(--color-primary)" }}>How is my information secured?</span>
                </div>
                <Checkbox onChange={null}>
                    <span
                        style={{
                            fontWeight: "bold",
                        }}
                    >
                        Use your $0.00 Account Credit first for automatic renewals
                    </span>{" "}
                    <span
                        style={{
                            color: "var(--color-primary)",
                        }}
                    >
                        ( add more credit )
                    </span>
                </Checkbox>

                <Card
                    style={{
                        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.1)",
                        marginTop: "10px",
                    }}
                    bodyStyle={{
                        padding: "2rem 3rem",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "1rem",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    gap: "1rem",
                                }}
                            >
                                <div>
                                    <img src="https://desi-fresh.b-cdn.net/components_static/visa_card.svg" alt="visa" height={20} />
                                </div>
                                <div>
                                    <div
                                        style={{
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Visa (****0000)
                                    </div>
                                    <div>Expiration Date 00/0000</div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    gap: "1rem",
                                    alignItems: "center",
                                }}
                            >
                                <Button
                                    type="primary"
                                    style={{
                                        padding: "0 3rem",
                                    }}
                                >
                                    Default
                                </Button>
                                <div
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                    role="button"
                                >
                                    Disable as Default
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "1rem",
                            }}
                        >
                            <div
                                style={{
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                }}
                            >
                                Edit
                            </div>
                            <div
                                style={{
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                }}
                            >
                                Delete
                            </div>
                        </div>
                    </div>
                </Card>

                <Card
                    style={{
                        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.1)",
                        marginTop: "10px",
                    }}
                    bodyStyle={{
                        padding: "2rem 3rem",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "1rem",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    gap: "1rem",
                                }}
                            >
                                <div>
                                    <img src="https://desi-fresh.b-cdn.net/components_static/mastercard.svg" alt="mastercard" height={20} />
                                </div>
                                <div>
                                    <div
                                        style={{
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Mastercard (****0000)
                                    </div>
                                    <div>Expiration Date 00/0000</div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    gap: "1rem",
                                    alignItems: "center",
                                }}
                            >
                                <Button
                                    type="default"
                                    style={{
                                        padding: "0 3rem",
                                    }}
                                >
                                    Default
                                </Button>
                                <div
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                    role="button"
                                >
                                    Disable as Default
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "1rem",
                            }}
                        >
                            <div
                                style={{
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                }}
                            >
                                Edit
                            </div>
                            <div
                                style={{
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                }}
                            >
                                Delete
                            </div>
                        </div>
                    </div>
                </Card>

                <div
                    style={{
                        marginTop: "1rem",
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    <Button icon={<PlusOutlined />} style={{ background: "#EAE8E8" }}>
                        Add new payment
                    </Button>
                </div>
            </Card> */}
        </CustomerLayout>
    );
};

export default CustomerDataPayment;
